<template>

  <div class="vflex">

    <div class="vflex-row-0 p-3">
      <div class="d-flex flex-wrap">
        <div 
          class="mr-2" 
          v-if="selected.length">
          <JobMassiveAction />
        </div>
        <div class="mr-2">
          <job-board-filters
            @setFilters="setFilters">
            </job-board-filters>
        </div>
        <div class="ml-auto">
          <button
            v-if="permissions.includes('manage_candidates')"
            type="button"
            class="btn btn-secondary"
            @click="showCandidateCreateModal">
            + <i class="far fa-user hide-bigger-sm" /> <span class="hide-less-sm">{{ $t('New candidate') }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <creating
        v-if="creating"
        height="100%" />

      <div 
        class="kanban"
        v-if="!creating && job.stages.length"
        :class="{'box-loading': loading}"
        v-connectedDroppable="{onUpdate: onStageUpdate, disabled: !permissions.includes('manage_candidates')}">

        <job-board-stages
          v-for="(stage, index) in job.stages"
          :key="index"
          :stage="stage"
          :status="filters['status']"
          :candidates="candidates"
          :boardFilters="boardFilters">
          </job-board-stages>

      </div>
    </div>

    <div 
      class="vflex-row-0"
      v-if="candidate_create_modal">
      <candidate-create-form
        @hideModal="hideCandidateCreateModal"
        @saved="savedCandidateCreateModal" 
        :initCandidate="candidate_create_modal">
        </candidate-create-form>
    </div>

  </div>

</template>

<script>
import CandidateCreateForm from '@/components/CandidateCreateForm/CandidateCreateForm'
import JobBoardStages from './JobBoardStages'
import JobBoardFilters from './JobBoardFilters'
import JobMassiveAction from '../JobMassiveAction/JobMassiveAction'

export default {
  name: 'JobBoard',
  components: {
    CandidateCreateForm,
    JobBoardFilters,
    JobBoardStages,
    JobMassiveAction
  },
  data () {
    return {
      loading: true,
      creating: true,
      candidate_create_modal: false,
      filters: {
        'status': 'qualified'
      }
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    selected () {
      return this.$store.getters.getCandidateSelectedIds
    },
    job () {
      return this.$store.getters.getJob
    },
    candidates () {
      return this.$store.getters.getCandidateBoards
    },
    boardFilters () {
      return {
        ...this.filters,
        'job_id': this.job._id,
        'limit': 30
      }
    }
  },
  created () {
    this.$store.dispatch('resetCandidateSelected')
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      this.$store
      .dispatch('selectCandidateBoard', this.boardFilters)
      .then((result) => {
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.filters = filters
      this.loadData()
    },
    /*
    showCandidateCreateModal
    */
    showCandidateCreateModal () {
      this.candidate_create_modal = {
        job_id: this.job._id
      }
    },
    hideCandidateCreateModal () {
      this.candidate_create_modal = false
    },
    savedCandidateCreateModal (data) {
      this.$store.commit('ADDEND_CANDIDATEBOARD_SELECT_IDS', [data._id])
      this.hideCandidateCreateModal()
    },
    /*
    onStageUpdate
    */
    onStageUpdate (data) {
      const item = JSON.parse(data.item)
      const candidate = this.$store.getters['entities/candidates/find'](item.candidate_id)

      const updatedCandidate = {
        ...candidate,
        placements: candidate.placements.map(placement => {
          if (String(placement._id) === String(item.placement_id)) {
            return {
              ...placement,
              stage_id: {_id: data.toList},
              stage_date: new Date().toISOString()
            }
          }
          return placement
        })
      }

      this.$store.dispatch('entities/candidates/insertOrUpdate', {data: updatedCandidate})

      // update api placement
      this.$store.dispatch('movePlacement', {
        _id: item.placement_id,
        stage_id: data.toList
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.kanban{
  width: 100%;
  height: 100%;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Job/JobBoard/JobBoard.vue